import React, { useContext, useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';

import UiContext from 'common/UiContext/UiContext';
import useApi from 'common/useApi';
import useFormApiErrors from 'common/useFormApiErrors';

const OtpChallenge = ({ close }: { close(): void }) => {
  const { openModal } = useContext(UiContext);
  const formMethods = useForm({ mode: 'onChange' });
  const { handleSubmit, register, formState: { isSubmitting, isValid, isDirty }, setError, setValue } = formMethods;
  const { error, isLoading, isFetching, isError, isSuccess, mutate } = useApi('post', '/api/me/verify-token');

  useFormApiErrors(isError, error, setError, isSuccess, 'Token verified');

  const onSubmit = ({ token }: Record<string, string>) => {
    mutate({ token });
  };

  useEffect(() => {
    if(isSuccess) {
      setValue('token', null);
      close();
      openModal!('Otp');
    }
  }, [isSuccess]);

  const formDisabled = isSubmitting || isLoading || isFetching || (!isValid && isDirty);

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <label>
          <p>Enter the one-time password generated by your OTP app</p>
          <input
            type='text'
            placeholder='######'
            {...register('token', {
              minLength: {
                message: 'Token must be exactly 6 characters long',
                value: 6,
              },
              maxLength: {
                message: 'Token must be exactly 6 characters long',
                value: 6,
              },
              required: 'Token can\'t be blank',
            })}
          />
        </label>


        <button className='secondary big' onClick={() => close()}>Cancel</button>
        <button type='submit' className='primary big' disabled={formDisabled}>Verify</button>
      </form>
    </FormProvider>
  );
};

export default OtpChallenge;